import { LocationQueryValue } from 'vue-router';

import { $axios } from './axiosInstance';

export async function getLoginLink(lang: string): Promise<any> {
	const axiosInstance = $axios();
	const url = 'api/user/login-link';
	const res = await axiosInstance.get(url, {
		params: {
			lang: useLowerCase(lang),
		},
	});
	return res.data;
}

export async function getLogoutLink(): Promise<any> {
	const axiosInstance = $axios();
	const url = 'api/user/logout-link';
	const res = await axiosInstance.get(url);
	return res.data;
}

export async function getAccountLink(lang: string): Promise<any> {
	const axiosInstance = $axios();
	const url = 'api/user/center-link';
	const res = await axiosInstance.get(url, {
		params: {
			lang: useLowerCase(lang),
		},
	});
	return res.data;
}

export async function login(
	code: LocationQueryValue | LocationQueryValue[],
	state: LocationQueryValue | LocationQueryValue[],
): Promise<any> {
	const axiosInstance = $axios();
	const url = 'api/user/login';
	const res = await axiosInstance.post(url, {
		code,
		state,
	});
	return res.data;
}

export async function logout(): Promise<any> {
	const axiosInstance = $axios();
	const url = 'api/user/logout';
	const res = await axiosInstance.post(url);
	return res.data;
}
